/* eslint-disable comma-dangle */

export default {
    address: [
        'user-input',
        'map',
        'highway',
        'underground'
    ],
    'about-object': [
        'common/cadastral-number',
        'area-land',
        'land-status',
        'permitted-use-type',
        'has-investment-project',
        'has-encumbrances',
        'land-electricity',
        'land-gas',
        'land-drainage',
        'land-water',
        'driveway-type'
    ],
    'about-building': [],
    'price-and-deal-terms': [
        'price-rate',
        'included-options',
        'lease-type-v2',
        'min-lease-term',
        'has-grace-period',
        {
          name: 'visual-divider',
          hideOnMobile: true,
        },
        'security-deposit',
        'prepay-type',
        'fee'
    ]
};
